/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Tree from "react-animated-tree";
import * as eventServices from "../services/eventService";
import {
    staticContentsImagePath as BASE_IMAGE_PATH,
    OPERATOR_ID,
} from "../configs/const";
import {
    casinoList,
    showBinary,
    showEsportLink,
    showSportsBookLink,
    showKabaddi,
    showElection,
    showClubGames,
    ShowSportsBattle,
    ElectionDisplayLabel,
} from "../configs/casinoShowList";
import { ALLPAGEDISPLAYWHATSAPP, APK_FILE_NAME } from "../configs/apkFileName";
let evtDataInterval = null;
let menuDataInterval = null;
// let clubgamesLinkShowTimeOut = null
export default class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openList: [],
            accessControl: {},
            eventData: [],
            cktGroup: {},
            socGroup: {},
            tenGroup: {},
            elecGroup: {},
            kbdGroup: {},
            horsGroup: {},
            houndGroup: {},
            showevolution: true,
            isOfficeChannel: false,
            menuData: null,
        };
    }
    toggleList(type) {
        let list = this.state.openList;
        let index = list.indexOf(type);
        if (index === -1) {
            list.push(type);
        } else {
            list.splice(index, 1);
        }
        this.setState({ openList: list });
    }
    organizeData(events) {
        const hierarchy = {};
        if (!events || events.length === 0) return hierarchy;
        let inplayData = {
            cktInplay: 0,
            socInplay: 0,
            tenInplay: 0,
            kbdInplay: 0,
            electInplay: 0,
            horsInplay: 0,
            houndInplay: 0,
            binaryInplay: 0,
        };
        let considered_event = [];
        let inplayEvents = [];
        events.forEach((event) => {
            const {
                eventTypeId,
                eventTypeName,
                competitionId,
                competitionName,
                eventid,
                eventname,
                openDate,
                marketId,
                marketName,
                status,
                inPlay,
            } = event;
            if (inPlay) {
                if (considered_event.indexOf(eventid) === -1) {
                    inplayEvents.push(event.eventid);
                }
                if (eventTypeId === "4" && considered_event.indexOf(eventid) === -1) {
                    inplayData.cktInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "1" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.socInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "2" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.tenInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "400" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.kbdInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "500" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.electInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "7" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.horsInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "4339" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.houndInplay++;
                    considered_event.push(eventid);
                } else if (
                    eventTypeId === "3" &&
                    considered_event.indexOf(eventid) === -1
                ) {
                    inplayData.binaryInplay++;
                    considered_event.push(eventid);
                }
            }
            localStorage.setItem("liveSportCount", JSON.stringify(inplayData));
            localStorage.setItem("inplayEvents", JSON.stringify(inplayEvents));
            // Initialize eventType in hierarchy if it doesn't exist
            if (!hierarchy[eventTypeId]) {
                hierarchy[eventTypeId] = {
                    eventTypeName: eventTypeName,
                    competitions: {},
                };
            }

            // Initialize competition in the eventType if it doesn't exist
            if (!hierarchy[eventTypeId].competitions[competitionId]) {
                hierarchy[eventTypeId].competitions[competitionId] = {
                    competitionName: competitionName,
                    events: {},
                };
            }

            // Add event to the competition
            hierarchy[eventTypeId].competitions[competitionId].events[eventid] = {
                eventname: eventname,
                openDate: openDate,
                marketId: marketId,
                marketName: marketName,
                status: status,
                inPlay: inPlay,
            };
        });

        return hierarchy;
    }
    componentDidMount() {
        const profData = JSON.parse(localStorage.getItem("profData"));
        if (!!profData) {
            this.setState({
                isOfficeChannel:
                    profData?.username === "office" ||
                    profData?.parents?.includes("office"),
            });
        }

        this.loadData();
        let menuUpdatedTimeStamp = localStorage.getItem("menuUpdatedTimeStamp");
        let liveSportCount = localStorage.getItem("liveSportCount");
        let inplayEvents = localStorage.getItem("inplayEvents");
        if (!menuUpdatedTimeStamp) {
            menuUpdatedTimeStamp = new Date().getTime();
            localStorage.setItem("menuUpdatedTimeStamp", menuUpdatedTimeStamp);
        }
        if ((menuUpdatedTimeStamp < new Date().getTime() - 30000) || (!liveSportCount && !inplayEvents)) {
            eventServices.getEventTreeList().then((res) => {
                let data = this.organizeData(res);
                this.setState({ menuData: data });
                localStorage.setItem("menuUpdatedTimeStamp", new Date().getTime());
            });
        }
        menuDataInterval = setInterval(() => {
            eventServices.getEventTreeList().then((res) => {
                let data = this.organizeData(res);
                this.setState({ menuData: data });
            });
        }, 30000);

        evtDataInterval = setInterval(function eventDataLoader() {
            clearInterval(evtDataInterval);
        });
        // this.evolutionMenuShowCheck();
    }

    evolutionMenuShowCheck() {
        let profData = localStorage.getItem("profData");
        if (!!profData) {
            profData = JSON.parse(localStorage.getItem("profData"));
            profData = profData.parents.indexOf("office") > -1; //profData.parents[profData.parents.length - 2] === 'office';
            this.setState({ showevolution: profData });
        }
    }
    componentWillUnmount() {
        clearInterval(evtDataInterval);
        clearInterval(menuDataInterval);
        // clearTimeout(clubgamesLinkShowTimeOut);
    }
    parseBook(data) {
        !!data &&
            data.length > 0 &&
            data.forEach((mkt, i) => {
                // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
                let book =
                    !!mkt.metadata && !!mkt.metadata.book
                        ? JSON.parse(mkt.metadata.book)
                        : null;
                data[i].metadata = {};
                data[i].metadata.book = book;
            });
        return data;
    }
    async loadDataBkp() {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        let accessControl = localStorage.getItem("accessControl");
        accessControl = !!accessControl ? JSON.parse(accessControl) : {};
        this.setState({ accessControl: accessControl });
        let homeData = localStorage.getItem("homeData");
        homeData = JSON.parse(homeData);
        if (!!homeData && homeData.length > 0) {
            setTimeout(() => {
                this.loadData();
            }, 10000);
        } else {
            setTimeout(() => {
                this.loadData();
            }, 1000);
        }
        let userEventData = !!homeData ? homeData : [];
        let events = [];
        !!userEventData &&
            userEventData.length > 0 &&
            userEventData.forEach((mkt, i) => {
                if (!mkt) {
                    return false;
                }
                let eventIndex = events.findIndex((x) => x.id === mkt.event.id);
                let market = { ...mkt.catalogue, ...mkt.marketCondition };
                market.metadata = mkt.metadata;
                market.marketBook =
                    !!market.metadata && !!market.metadata.book
                        ? market.metadata.book
                        : null;
                market.marketId = mkt.catalogue.marketId;
                if (market.provider !== "BETHUBS") {
                    if (
                        !market.marketBook ||
                        mkt.status === "CLOSED" ||
                        market.marketBook.status === "CLOSED" ||
                        market.marketBook.status === "INACTIVE"
                    ) {
                        return false;
                    }
                }
                if (eventIndex === -1) {
                    let evt = mkt.event;
                    evt.eventTypeId = mkt.eventType.id;
                    evt.eventType = mkt.eventType.name;
                    evt.competitionId = mkt.competition.id;
                    evt.compititionName = mkt.competition.name;
                    evt.markets = [market];
                    events.push(evt);
                } else {
                    events[eventIndex].markets.push(market);
                }
            });
        let cricketEvents = events.filter((e) => {
            return e.eventTypeId === "4";
        });
        let cktGroup = cricketEvents.reduce((r, a) => {
            r[a.competitionId] = [...(r[a.competitionId] || []), a];
            return r;
        }, {});

        let socEvents = events.filter((e) => {
            return e.eventTypeId === "1";
        });
        let socGroup = socEvents.reduce((r, a) => {
            r[a.competitionId] = [...(r[a.competitionId] || []), a];
            return r;
        }, {});

        let tenEvents = events.filter((e) => {
            return e.eventTypeId === "2";
        });
        let tenGroup = tenEvents.reduce((r, a) => {
            r[a.competitionId] = [...(r[a.competitionId] || []), a];
            return r;
        }, {});

        let elecEvents = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true
            ? events.filter((e) => {
                return e.eventTypeId === "500";
            })
            : [];
        let elecGroup = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true
            ? elecEvents.reduce((r, a) => {
                r[a.competitionId] = [...(r[a.competitionId] || []), a];
                return r;
            }, {})
            : [];

        let kbdEvents = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true
            ? events.filter((e) => {
                return e.eventTypeId === "400";
            })
            : [];
        let kbdGroup = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true
            ? kbdEvents.reduce((r, a) => {
                r[a.competitionId] = [...(r[a.competitionId] || []), a];
                return r;
            }, {})
            : [];

        let horsEvents = events.filter((e) => {
            return e.eventTypeId === "7";
        });
        let horsGroup = horsEvents.reduce((r, a) => {
            r[a.competitionId] = [...(r[a.competitionId] || []), a];
            return r;
        }, {});

        let houndEvents = events.filter((e) => {
            return e.eventTypeId === "4339";
        });
        let houndGroup = houndEvents.reduce((r, a) => {
            r[a.competitionId] = [...(r[a.competitionId] || []), a];
            return r;
        }, {});

        this.setState({
            cktGroup: cktGroup,
            socGroup: socGroup,
            tenGroup: tenGroup,
            kbdGroup: kbdGroup,
            elecGroup: elecGroup,
            horsGroup: horsGroup,
            houndGroup: houndGroup,
        });
    }
    async loadData() {
        let accessControl = localStorage.getItem("accessControl");
        accessControl = !!accessControl ? JSON.parse(accessControl) : {};
        this.setState({ accessControl: accessControl });
        // let homeData = localStorage.getItem("eventMenuDetails")
        // homeData = JSON.parse(homeData)

        // if (!!homeData && this.checkEventMenuDetailsHasData(homeData)) {
        //     setTimeout(() => { this.loadData() }, 10000)
        // } else {
        //     setTimeout(() => { this.loadData() }, 1000)
        // }

        // this.setState({ menuData: homeData });
    }
    checkEventMenuDetailsHasData(dtt) {
        const typeId = ["1", "2", "4", "7", "4339", "400", "500"];
        let hasdata = false;
        for (let i = 0; i < typeId.length; i++) {
            if (Object.keys(dtt[typeId[i]]).length > 0) {
                // && dtt[typeId[i]].events.length > 0){
                hasdata = true;
                break;
            }
        }
        return hasdata;
    }
    toggleCompetition(e) {
        let elem = e.target.parentNode.parentNode.firstChild;
        this.eventFire(elem, "click");
    }
    eventFire(el, etype) {
        if (el.fireEvent) {
            el.fireEvent("on" + etype);
        } else {
            var evObj = document.createEvent("Events");
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }
    openNav() {
        if (
            document.getElementById("sidebar") !== null &&
            (document.getElementById("sidebar").style.left === "-270px" ||
                document.getElementById("sidebar").style.left === "")
        )
            document.getElementById("sidebar").style.left = "0px";
        else
            document.getElementById("sidebar").style.left =
                document.documentElement.clientWidth > 574 ? "-270px" : "";
    }
    redirect(path) {
        let history = this.props.history;
        history.push(path);
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        let SclMd = localStorage.getItem("SocialMedia");
        if (!!SclMd && Object.keys(SclMd).length > 0) {
            SclMd = JSON.parse(SclMd);
        }
        let winnereventdic = localStorage.getItem("winnereventdic");
        if(!!winnereventdic){
            winnereventdic = JSON.parse(winnereventdic);
        }
        return (
            <div
                className={`col-left ${!!accData && Object.keys(accData).length > 0 ? "" : "col-left-login"
                    }`}
                id="sidebar"
            >
                <div className="sub_path over-wrap">
                    {(this.state.accessControl.sports ||
                        this.state.accessControl.binary) && (
                            <ul className="list-unstyled components">
                                <p>
                                    Popular{" "}
                                    <i
                                        className="fa fa-close pt-1 icon-toggle-right mobile-menu float-right"
                                        onClick={() => {
                                            this.openNav();
                                        }}
                                    ></i>
                                </p>
                                {!this.props.isMaintanance ? (
                                    <>
                                        <li
                                            onClick={() => {
                                                this.redirect("/home");
                                            }}
                                            className="tab-show"
                                        >
                                            <a
                                                aria-expanded={
                                                    window.location.pathname === "/home" ? true : false
                                                }
                                            >
                                                <span className="sports-icon homeside"></span> Home
                                            </a>
                                        </li>
                                        {this.state.accessControl.sports && (
                                            <li
                                                onClick={() => {
                                                    this.redirect("/inplay");
                                                }}
                                            >
                                                <a
                                                    aria-expanded={
                                                        window.location.pathname === "/inplay" ? true : false
                                                    }
                                                >
                                                    <span className="sports-icon inplayside"></span> In-Play
                                                </a>
                                            </li>
                                        )}
                                        {this.state.accessControl.sports &&
                                            !!accData &&
                                            Object.keys(accData).length > 0 && (
                                                <li
                                                    onClick={() => {
                                                        this.redirect("/multimarket");
                                                    }}
                                                >
                                                    <a>
                                                        <span className="sports-icon multimarketside"></span>{" "}
                                                        Multi Markets
                                                    </a>
                                                </li>
                                            )}
                                        {showSportsBookLink.shows && (
                                            <li
                                                onClick={() => {
                                                    this.redirect("/sportbook");
                                                }}
                                            >
                                                <a href={"/sportbook"}>
                                                    <span className="sports-icon sportbookside"></span>{" "}
                                                    SportsBook
                                                </a>
                                            </li>
                                        )}
                                        {
                                            this.state.accessControl.sports && !!winnereventdic && !!winnereventdic["eventDicByName"] && Object.keys(winnereventdic["eventDicByName"]).length > 0 && Object.keys(winnereventdic["eventDicByName"]).map((itm,i)=>{
                                                let itmm = winnereventdic["eventDicByName"][itm];
                                                if(!itmm.show){
                                                    return false;
                                                }
                                                if(!itmm.showInMenu){
                                                    return false;
                                                }
                                                return(
                                                    <li key={`0_${i}_${itm}`}>
                                                        <a href={itmm["url"]}>
                                                            <span className='sports-icon iplwinnerside'></span> {itmm["displayName"]}
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                        {/* {this.state.accessControl.sports &&
                                            <li>
                                                <a href={"/wbbl2025"}>
                                                    <span className='sports-icon iplwinnerside'></span> WBBL 2025
                                                </a>
                                            </li>
                                        } */}

                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/wt20"}>
                                        <span className='sports-icon iplwinnerside'></span> WC Winner 2024
                                    </a>
                                </li>
                            } */}

                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/ivl"}>
                                        <span className='sports-icon iplwinnerside'></span> IVL T10
                                    </a>
                                </li>
                            } */}
                                        {/* {this.state.accessControl.sports && (
                                            <li>
                                                <a href={"/ipl"}>
                                                    <span className="sports-icon iplwinnerside"></span> IPL
                                                    2025
                                                </a>
                                            </li>
                                        )} */}
                                        {/* {this.state.accessControl.sports && (
                                            <li>
                                                <a href={"/wplwinner"}>
                                                    <span className="sports-icon iplwinnerside"></span> WPL
                                                    2025
                                                </a>
                                            </li>
                                        )} */}
                                        {!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true &&
                                            !!this.state.elecGroup &&
                                            Object.keys(this.state.elecGroup).length > 0 && (
                                                <li>
                                                    <a
                                                        style={{ textTransform: "capitalize" }}
                                                        onClick={() => {
                                                            this.toggleList("500");
                                                        }}
                                                        data-toggle="collapse"
                                                        className="dropdown-toggle"
                                                    >
                                                        <span className="sports-icon electionside"></span>{" "}
                                                        {ElectionDisplayLabel}
                                                    </a>
                                                    {!!this.state.menuData &&
                                                        !!this.state.menuData["500"] &&
                                                        Object.keys(this.state.menuData["500"].competitions)
                                                            .length > 0 && (
                                                            <div
                                                                id="cricketSubmenu"
                                                                style={{
                                                                    display:
                                                                        this.state.openList.indexOf("500") === -1
                                                                            ? "none"
                                                                            : "block",
                                                                }}
                                                            >
                                                                <div id="sidetree">
                                                                    <ul id="tree">
                                                                        <li style={{ marginLeft: 15 }}>
                                                                            {Object.keys(
                                                                                this.state.menuData["500"].competitions
                                                                            ).map((comp, j) => {
                                                                                let firstEvt =
                                                                                    this.state.menuData["500"].competitions[
                                                                                    comp
                                                                                    ];
                                                                                return (
                                                                                    <Tree
                                                                                        key={"crickcomp" + comp}
                                                                                        content={
                                                                                            <>
                                                                                                <span
                                                                                                    className="treeviewnode"
                                                                                                    onClick={(e) => {
                                                                                                        this.toggleCompetition(e);
                                                                                                    }}
                                                                                                    style={{
                                                                                                        fontSize: 11,
                                                                                                        color: "#000",
                                                                                                        cursor: "pointer",
                                                                                                    }}
                                                                                                >
                                                                                                    {firstEvt.competitionName}
                                                                                                </span>
                                                                                            </>
                                                                                        }
                                                                                    >
                                                                                        {!!firstEvt.events &&
                                                                                            Object.keys(firstEvt.events).map(
                                                                                                (evt, k) => {
                                                                                                    let event =
                                                                                                        firstEvt.events[evt];
                                                                                                    return (
                                                                                                        <Tree
                                                                                                            key={"crickevt" + evt}
                                                                                                            content={
                                                                                                                <span
                                                                                                                    className="treeviewnode"
                                                                                                                    title={event.eventname}
                                                                                                                    onClick={() => {
                                                                                                                        this.props.history.push(
                                                                                                                            "/event/500/" + evt
                                                                                                                        );
                                                                                                                    }}
                                                                                                                    style={{
                                                                                                                        color: "#000",
                                                                                                                        fontSize: 11,
                                                                                                                        cursor: "pointer",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {event.eventname}
                                                                                                                </span>
                                                                                                            }
                                                                                                        />
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                    </Tree>
                                                                                );
                                                                            })}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        )}
                                                </li>
                                            )}
                                        {!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && (
                                            <li>
                                                <a
                                                    style={{ textTransform: "capitalize" }}
                                                    onClick={() => {
                                                        this.toggleList("400");
                                                    }}
                                                    data-toggle="collapse"
                                                    className="dropdown-toggle"
                                                >
                                                    <span className="sports-icon kabaddiside"></span>{" "}
                                                    Kabaddi
                                                </a>
                                                {!!this.state.menuData &&
                                                    !!this.state.menuData["400"] &&
                                                    Object.keys(this.state.menuData["400"].competitions)
                                                        .length > 0 && (
                                                        <div
                                                            id="cricketSubmenu"
                                                            style={{
                                                                display:
                                                                    this.state.openList.indexOf("400") === -1
                                                                        ? "none"
                                                                        : "block",
                                                            }}
                                                        >
                                                            <div id="sidetree">
                                                                <ul id="tree">
                                                                    <li style={{ marginLeft: 15 }}>
                                                                        {Object.keys(
                                                                            this.state.menuData["400"].competitions
                                                                        ).map((comp, j) => {
                                                                            let firstEvt =
                                                                                this.state.menuData["400"].competitions[
                                                                                comp
                                                                                ];
                                                                            return (
                                                                                <Tree
                                                                                    key={"crickcomp" + comp}
                                                                                    content={
                                                                                        <>
                                                                                            <span
                                                                                                className="treeviewnode"
                                                                                                onClick={(e) => {
                                                                                                    this.toggleCompetition(e);
                                                                                                }}
                                                                                                style={{
                                                                                                    fontSize: 11,
                                                                                                    color: "#000",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            >
                                                                                                {firstEvt.competitionName}
                                                                                            </span>
                                                                                        </>
                                                                                    }
                                                                                >
                                                                                    {!!firstEvt.events &&
                                                                                        Object.keys(firstEvt.events).map(
                                                                                            (evt, k) => {
                                                                                                let event = firstEvt.events[evt];
                                                                                                return (
                                                                                                    <Tree
                                                                                                        key={"crickevt" + evt}
                                                                                                        content={
                                                                                                            <span
                                                                                                                className="treeviewnode"
                                                                                                                title={event.eventname}
                                                                                                                onClick={() => {
                                                                                                                    this.props.history.push(
                                                                                                                        "/event/400/" + evt
                                                                                                                    );
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    color: "#000",
                                                                                                                    fontSize: 11,
                                                                                                                    cursor: "pointer",
                                                                                                                }}
                                                                                                            >
                                                                                                                {event.eventname}
                                                                                                            </span>
                                                                                                        }
                                                                                                    />
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                </Tree>
                                                                            );
                                                                        })}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )}
                                            </li>
                                        )}


                                        {ShowSportsBattle && (
                                            <li
                                                onClick={() => {
                                                    this.redirect("/sportsbattleevent");
                                                }}
                                            >
                                                <a href={"/sportsbattleevent"}>
                                                    <span className="sports-icon sportbookside"></span>{" "}
                                                    SportsBook
                                                </a>
                                            </li>
                                        )}

                                        <li>
                                            <a
                                                style={{ textTransform: "capitalize" }}
                                                onClick={() => {
                                                    this.toggleList("4");
                                                }}
                                                data-toggle="collapse"
                                                className="dropdown-toggle"
                                            >
                                                <span className="sports-icon cricketside"></span> Cricket
                                            </a>
                                            {!!this.state.menuData &&
                                                !!this.state.menuData["4"] &&
                                                Object.keys(this.state.menuData["4"].competitions)
                                                    .length > 0 && (
                                                    <div
                                                        id="cricketSubmenu"
                                                        style={{
                                                            display:
                                                                this.state.openList.indexOf("4") === -1
                                                                    ? "none"
                                                                    : "block",
                                                        }}
                                                    >
                                                        <div id="sidetree">
                                                            <ul id="tree">
                                                                <li style={{ marginLeft: 15 }}>
                                                                    {Object.keys(
                                                                        this.state.menuData["4"].competitions
                                                                    ).map((comp, j) => {
                                                                        let firstEvt =
                                                                            this.state.menuData["4"].competitions[comp];
                                                                        return (
                                                                            <Tree
                                                                                key={"crickcomp" + comp}
                                                                                content={
                                                                                    <>
                                                                                        <span
                                                                                            className="treeviewnode"
                                                                                            onClick={(e) => {
                                                                                                this.toggleCompetition(e);
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: "#000",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {firstEvt.competitionName}
                                                                                        </span>
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {!!firstEvt.events &&
                                                                                    Object.keys(firstEvt.events).map(
                                                                                        (evt, k) => {
                                                                                            let event = firstEvt.events[evt];
                                                                                            return (
                                                                                                <Tree
                                                                                                    key={"crickevt" + evt}
                                                                                                    content={
                                                                                                        <span
                                                                                                            className="treeviewnode"
                                                                                                            title={event.eventname}
                                                                                                            onClick={() => {
                                                                                                                this.props.history.push(
                                                                                                                    !!winnereventdic && 
                                                                                                                    !!winnereventdic["eventDicByID"] && 
                                                                                                                    winnereventdic["eventDicByID"][evt] 
                                                                                                                    ? winnereventdic["eventDicByID"][evt] 
                                                                                                                    : ("/event/4/" + evt)
                                                                                                                );
                                                                                                            }}
                                                                                                            style={{
                                                                                                                color: "#000",
                                                                                                                fontSize: 11,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            {event.eventname}
                                                                                                        </span>
                                                                                                    }
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Tree>
                                                                        );
                                                                    })}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                        </li>
                                        <li>
                                            <a
                                                style={{ textTransform: "capitalize" }}
                                                onClick={() => {
                                                    this.toggleList("1");
                                                }}
                                                data-toggle="collapse"
                                                className="dropdown-toggle"
                                            >
                                                <span className="sports-icon soccerside"></span> Soccer
                                            </a>
                                            {!!this.state.menuData &&
                                                !!this.state.menuData["1"] &&
                                                Object.keys(this.state.menuData["1"].competitions)
                                                    .length > 0 && (
                                                    <div
                                                        id="cricketSubmenu"
                                                        style={{
                                                            display:
                                                                this.state.openList.indexOf("1") === -1
                                                                    ? "none"
                                                                    : "block",
                                                        }}
                                                    >
                                                        <div id="sidetree">
                                                            <ul id="tree">
                                                                <li style={{ marginLeft: 15 }}>
                                                                    {Object.keys(
                                                                        this.state.menuData["1"].competitions
                                                                    ).map((comp, j) => {
                                                                        let firstEvt =
                                                                            this.state.menuData["1"].competitions[comp];
                                                                        return (
                                                                            <Tree
                                                                                key={"crickcomp" + comp}
                                                                                content={
                                                                                    <>
                                                                                        <span
                                                                                            className="treeviewnode"
                                                                                            onClick={(e) => {
                                                                                                this.toggleCompetition(e);
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: "#000",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {firstEvt.competitionName}
                                                                                        </span>
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {!!firstEvt.events &&
                                                                                    Object.keys(firstEvt.events).map(
                                                                                        (evt, k) => {
                                                                                            let event = firstEvt.events[evt];
                                                                                            return (
                                                                                                <Tree
                                                                                                    key={"crickevt" + evt}
                                                                                                    content={
                                                                                                        <span
                                                                                                            className="treeviewnode"
                                                                                                            title={event.eventname}
                                                                                                            onClick={() => {
                                                                                                                this.props.history.push(
                                                                                                                    "/event/1/" + evt
                                                                                                                );
                                                                                                            }}
                                                                                                            style={{
                                                                                                                color: "#000",
                                                                                                                fontSize: 11,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            {event.eventname}
                                                                                                        </span>
                                                                                                    }
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Tree>
                                                                        );
                                                                    })}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                        </li>
                                        <li>
                                            <a
                                                style={{ textTransform: "capitalize" }}
                                                onClick={() => {
                                                    this.toggleList("2");
                                                }}
                                                data-toggle="collapse"
                                                className="dropdown-toggle"
                                            >
                                                <span className="sports-icon tennisside"></span> Tennis
                                            </a>
                                            {!!this.state.menuData &&
                                                !!this.state.menuData["2"] &&
                                                Object.keys(this.state.menuData["2"].competitions)
                                                    .length > 0 && (
                                                    <div
                                                        id="cricketSubmenu"
                                                        style={{
                                                            display:
                                                                this.state.openList.indexOf("2") === -1
                                                                    ? "none"
                                                                    : "block",
                                                        }}
                                                    >
                                                        <div id="sidetree">
                                                            <ul id="tree">
                                                                <li style={{ marginLeft: 15 }}>
                                                                    {Object.keys(
                                                                        this.state.menuData["2"].competitions
                                                                    ).map((comp, j) => {
                                                                        let firstEvt =
                                                                            this.state.menuData["2"].competitions[comp];
                                                                        return (
                                                                            <Tree
                                                                                key={"crickcomp" + comp}
                                                                                content={
                                                                                    <>
                                                                                        <span
                                                                                            className="treeviewnode"
                                                                                            onClick={(e) => {
                                                                                                this.toggleCompetition(e);
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: "#000",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {firstEvt.competitionName}
                                                                                        </span>
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {!!firstEvt.events &&
                                                                                    Object.keys(firstEvt.events).map(
                                                                                        (evt, k) => {
                                                                                            let event = firstEvt.events[evt];
                                                                                            return (
                                                                                                <Tree
                                                                                                    key={"crickevt" + evt}
                                                                                                    content={
                                                                                                        <span
                                                                                                            className="treeviewnode"
                                                                                                            title={event.eventname}
                                                                                                            onClick={() => {
                                                                                                                this.props.history.push(
                                                                                                                    !!winnereventdic && 
                                                                                                                    !!winnereventdic["eventDicByID"] && 
                                                                                                                    winnereventdic["eventDicByID"][evt] 
                                                                                                                    ? winnereventdic["eventDicByID"][evt] 
                                                                                                                    : ("/event/4/" + evt)
                                                                                                                );
                                                                                                            }}
                                                                                                            style={{
                                                                                                                color: "#000",
                                                                                                                fontSize: 11,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            {event.eventname}
                                                                                                        </span>
                                                                                                    }
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Tree>
                                                                        );
                                                                    })}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                        </li>
                                        {((showClubGames.onlyInOfficeChnl
                                            ? this.state.isOfficeChannel
                                            : false) ||
                                            showClubGames.show) &&
                                            !!accData &&
                                            Object.keys(accData).length > 0 && (
                                                <li
                                                    onClick={() => {
                                                        this.redirect("/clubgames");
                                                    }}
                                                >
                                                    <a href={"/clubgames"}>
                                                        <img
                                                            alt=""
                                                            src={
                                                                BASE_IMAGE_PATH +
                                                                "/casino/banner/images/indian-poker-icon.svg"
                                                            }
                                                            className="ball-images-tab"
                                                        />{" "}
                                                        Club Games
                                                    </a>
                                                </li>
                                            )}
                                        <li>
                                            <a
                                                style={{ textTransform: "capitalize" }}
                                                onClick={() => {
                                                    this.toggleList("7");
                                                }}
                                                data-toggle="collapse"
                                                className="dropdown-toggle"
                                            >
                                                <span className="sports-icon horseside"></span> Horse
                                            </a>
                                            {!!this.state.menuData &&
                                                !!this.state.menuData["7"] &&
                                                Object.keys(this.state.menuData["7"].competitions)
                                                    .length > 0 && (
                                                    <div
                                                        id="cricketSubmenu"
                                                        style={{
                                                            display:
                                                                this.state.openList.indexOf("7") === -1
                                                                    ? "none"
                                                                    : "block",
                                                        }}
                                                    >
                                                        <div id="sidetree">
                                                            <ul id="tree">
                                                                <li style={{ marginLeft: 15 }}>
                                                                    {Object.keys(
                                                                        this.state.menuData["7"].competitions
                                                                    ).map((comp, j) => {
                                                                        let firstEvt =
                                                                            this.state.menuData["7"].competitions[comp];
                                                                        return (
                                                                            <Tree
                                                                                key={"crickcomp" + comp}
                                                                                content={
                                                                                    <>
                                                                                        <span
                                                                                            className="treeviewnode"
                                                                                            onClick={(e) => {
                                                                                                this.toggleCompetition(e);
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: "#000",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {firstEvt.competitionName}
                                                                                        </span>
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {!!firstEvt.events &&
                                                                                    Object.keys(firstEvt.events).map(
                                                                                        (evt, k) => {
                                                                                            let event = firstEvt.events[evt];
                                                                                            return (
                                                                                                <Tree
                                                                                                    key={"crickevt" + evt}
                                                                                                    content={
                                                                                                        <span
                                                                                                            className="treeviewnode"
                                                                                                            title={event.eventname}
                                                                                                            onClick={() => {
                                                                                                                this.props.history.push(
                                                                                                                    !!winnereventdic && 
                                                                                                                    !!winnereventdic["eventDicByID"] && 
                                                                                                                    winnereventdic["eventDicByID"][evt] 
                                                                                                                    ? winnereventdic["eventDicByID"][evt] 
                                                                                                                    : ("/event/4/" + evt)
                                                                                                                );
                                                                                                            }}
                                                                                                            style={{
                                                                                                                color: "#000",
                                                                                                                fontSize: 11,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            {event.eventname}
                                                                                                        </span>
                                                                                                    }
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Tree>
                                                                        );
                                                                    })}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                        </li>
                                        <li>
                                            <a
                                                style={{ textTransform: "capitalize" }}
                                                onClick={() => {
                                                    this.toggleList("4339");
                                                }}
                                                data-toggle="collapse"
                                                className="dropdown-toggle"
                                            >
                                                <span className="sports-icon greyhoundside"></span>{" "}
                                                Greyhound
                                            </a>
                                            {!!this.state.menuData &&
                                                !!this.state.menuData["4339"] &&
                                                Object.keys(this.state.menuData["4339"].competitions)
                                                    .length > 0 && (
                                                    <div
                                                        id="cricketSubmenu"
                                                        style={{
                                                            display:
                                                                this.state.openList.indexOf("4339") === -1
                                                                    ? "none"
                                                                    : "block",
                                                        }}
                                                    >
                                                        <div id="sidetree">
                                                            <ul id="tree">
                                                                <li style={{ marginLeft: 15 }}>
                                                                    {Object.keys(
                                                                        this.state.menuData["4339"].competitions
                                                                    ).map((comp, j) => {
                                                                        let firstEvt =
                                                                            this.state.menuData["4339"].competitions[
                                                                            comp
                                                                            ];
                                                                        return (
                                                                            <Tree
                                                                                key={"crickcomp" + comp}
                                                                                content={
                                                                                    <>
                                                                                        <span
                                                                                            className="treeviewnode"
                                                                                            onClick={(e) => {
                                                                                                this.toggleCompetition(e);
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: "#000",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {firstEvt.competitionName}
                                                                                        </span>
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {!!firstEvt.events &&
                                                                                    Object.keys(firstEvt.events).map(
                                                                                        (evt, k) => {
                                                                                            let event = firstEvt.events[evt];
                                                                                            return (
                                                                                                <Tree
                                                                                                    key={"crickevt" + evt}
                                                                                                    content={
                                                                                                        <span
                                                                                                            className="treeviewnode"
                                                                                                            title={event.eventname}
                                                                                                            onClick={() => {
                                                                                                                this.props.history.push(
                                                                                                                    !!winnereventdic && 
                                                                                                                    !!winnereventdic["eventDicByID"] && 
                                                                                                                    winnereventdic["eventDicByID"][evt] 
                                                                                                                    ? winnereventdic["eventDicByID"][evt] 
                                                                                                                    : ("/event/4/" + evt)
                                                                                                                );
                                                                                                            }}
                                                                                                            style={{
                                                                                                                color: "#000",
                                                                                                                fontSize: 11,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            {event.eventname}
                                                                                                        </span>
                                                                                                    }
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Tree>
                                                                        );
                                                                    })}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                        </li>
                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/ipl"}>
                                        <span className='sports-icon iplwinnerside'></span> IPL Winner 2023
                                    </a>
                                </li>
                            } */}

                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/bigbash2022"}>
                                        <span className='sports-icon iplwinnerside'></span> Big Bash 2022
                                    </a>
                                </li>
                            } */}
                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/pslwinner"}>
                                        <span className='sports-icon iplwinnerside'></span> PSL Winner 2023
                                    </a>
                                </li>
                            }
                            {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/wplwinner"}>
                                        <span className='sports-icon iplwinnerside'></span> WPL Winner 2023
                                    </a>
                                </li>
                            } */}
                                        {/* {this.state.accessControl.sports && 
                                <li>
                                    <a href={"/fifacup2022"}>
                                        <span className='sports-icon iplwinnerside'></span> FIFA CUP 2022
                                    </a>
                                </li>
                            } */}
                                        {/* {this.state.accessControl.sports && 
                                <li onClick={() => { this.redirect("/multimarket") }} >
                                    <a><span className='sports-icon electionside'></span> Election</a>
                                </li>
                            } */}
                                    </>
                                ) : (
                                    <>
                                        <li
                                            onClick={() => {
                                                this.redirect("/maintanance");
                                            }}
                                            className="tab-show"
                                        >
                                            <a
                                                aria-expanded={
                                                    window.location.pathname === "/maintanance"
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <i className="fa fa-home"></i> Home
                                            </a>
                                        </li>
                                        <li
                                            onClick={() => {
                                                this.redirect("/games/3droulette");
                                            }}
                                        >
                                            <a>
                                                <img
                                                    alt=""
                                                    src={BASE_IMAGE_PATH + "/images/roulette.svg"}
                                                    className="ball-images-tab"
                                                />{" "}
                                                3D Roulette
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        )}
                    {!this.props.isMaintanance && this.state.accessControl.casino && (
                        <ul className="list-unstyled components bb-none">
                            {/* <li onClick={() => { this.redirect("/indianpoker") }} >
                            <a href={"/indianpoker"}>
                                <span className='sports-icon indianpokerside'></span> Indian Poker
                            </a>
                        </li>
                        {OPERATOR_ID === "IND" && <li><a href={"/indianpoker2"}><img alt="" src={BASE_IMAGE_PATH+"/casino/banner/images/indian-poker-icon.svg"} className="ball-images-tab"/> Indian Poker 2</a></li>}
                        {this.state.showevolution && <li onClick={() => { this.redirect("/evolution") }} ><a href={"/evolution"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/casino-icon.svg"} className="ball-images-tab" /> Evolution</a></li>}
                        {/* <li onClick={() => { this.redirect("/casino") }} ><a href={"/casino"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/casino-icon.svg"} className="ball-images-tab" /> Casino</a></li> *}
                        <li onClick={() => { this.redirect("/casino") }} >
                            <a href={"/casino"}>
                                <span className='sports-icon casinoside'></span> Casino
                            </a>
                        </li> */}

                            {this.state.accessControl.casino &&
                                Object.values(casinoList).map((itm, i) => {
                                    return (
                                        itm.show && (
                                            <>
                                                {/* {itm.provider === 'VIVO' ?
                                            this.state.isOfficeChannel &&
                                            <li onClick={() => { this.redirect(itm.url) }} >
                                                <a key={`4_${itm.provider}_${i}`} href={itm.url}>
                                                    {!!itm.iconImg ?
                                                        <img className="ball-images-tab" src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`} alt="" />
                                                        :
                                                        <span className={`sports-icon ${itm.iconClass}side`}></span>
                                                    }
                                                    {itm.displayName}
                                                </a>
                                            </li>
                                            :
                                        } */}

                                                {itm.provider === "DRC" ? (
                                                    <li
                                                        onClick={() => {
                                                            this.redirect("/casino2");
                                                        }}
                                                    >
                                                        <a href={"/casino2"}>
                                                            <img
                                                                alt=""
                                                                src={
                                                                    BASE_IMAGE_PATH +
                                                                    "/casino/banner/images/casino-icon.svg"
                                                                }
                                                                className="ball-images-tab"
                                                            />{" "}
                                                            Casino II
                                                        </a>
                                                    </li>
                                                ) : (
                                                    itm.provider === "INOUT" ?
                                                        <li
                                                            onClick={() => {
                                                                this.redirect(itm.url);
                                                            }}
                                                        >
                                                            <a key={`4_${itm.provider}_${i}`} href={itm.url}>
                                                                <img
                                                                    className="ball-images-tab-inout-m"
                                                                    src={`${BASE_IMAGE_PATH}/casino/banner/images/inout-icon-b.svg`}
                                                                    alt=""
                                                                />
                                                                {itm.displayName}
                                                            </a>
                                                        </li>
                                                        :
                                                        (
                                                            <li
                                                                onClick={() => {
                                                                    this.redirect(itm.url);
                                                                }}
                                                            >
                                                                <a key={`4_${itm.provider}_${i}`} href={itm.url}>
                                                                    {!!itm.iconImg ? (
                                                                        <img
                                                                            className="ball-images-tab"
                                                                            src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`}
                                                                            alt=""
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            className={`sports-icon ${itm.iconClass}side`}
                                                                        ></span>
                                                                    )}
                                                                    {itm.displayName}
                                                                </a>
                                                            </li>
                                                        )
                                                )}
                                            </>
                                        )
                                    );
                                })}
                            {document.documentElement.clientWidth <= 990 && (
                                <li>
                                    <a
                                        href="#"
                                        onClick={() => {
                                            window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk`;
                                        }}
                                    >
                                        <i className="fa fa-mobile mr-1"></i> Download APK
                                    </a>
                                </li>
                            )}
                            {
                                !!SclMd && !!SclMd?.ALLPAGEDISPLAYWHATSAPP && (
                                    <li>
                                        <a href={SclMd?.ALLPAGEDISPLAYWHATSAPP} target="_blank" rel="noreferrer">
                                            <span className="sports-icon whatsappside"></span>{" "}
                                            Whatsapp
                                        </a>
                                    </li>
                                )
                                // <li>
                                //     <a class="whats-apps-menu" href="https://wa.me/+919661491992" target="_blank" rel="noreferrer">
                                //         <img src="https://images.staticcontent.io/casino/banner/images/whatsapp-icon-new.png" alt="" />whatsapp
                                //     </a>
                                // </li>
                            }

                            {/* <li onClick={() => { this.redirect("/casino2") }} ><a href={"/casino2"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/casino-icon.svg"} className="ball-images-tab" /> Casino II</a></li> */}
                            {/* <li onClick={() => { this.redirect("/virtualsports") }} >
                            <a href={"/virtualsports"}>
                                <span className='sports-icon virtualgameside'></span> V-Sports
                            </a>
                        </li> */}
                            {showEsportLink.show && (
                                <li
                                    onClick={() => {
                                        this.redirect("/esport");
                                    }}
                                >
                                    <a href={"/esport"}>
                                        <span className="sports-icon sportbookside"></span> E-Sports
                                    </a>
                                </li>
                            )}
                        </ul>
                    )}
                    {!this.props.isMaintanance && this.state.accessControl && (
                        <ul className="list-unstyled components">
                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect("/worldt20") }} ><a href={"/worldt20"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/trophy.svg"} className="ball-images-tab" /> WorldCup Winner</a></li>} */}
                            {showBinary && this.state.accessControl.binary && (
                                <li
                                    onClick={() => {
                                        this.redirect("/binary");
                                    }}
                                >
                                    <a href={"/binary"}>
                                        <span className="sports-icon binaryside"></span> Binary
                                    </a>
                                </li>
                            )}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}
